import React from "react";
import { RefreshCw, TriangleAlert } from "lucide-react";

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("Protected app crashed:", error, info);
    }

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
                <div className="w-full max-w-md rounded-[28px] border border-slate-200 bg-white p-6 text-center shadow-2xl shadow-slate-200/80">
                    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-50 text-rose-600">
                        <TriangleAlert size={28} />
                    </div>
                    <p className="text-xs font-bold uppercase tracking-[0.28em] text-slate-400">
                        App Error
                    </p>
                    <h1 className="mt-2 text-2xl font-bold text-slate-950">
                        The workspace could not load
                    </h1>
                    <p className="mt-3 text-sm leading-6 text-slate-600">
                        A protected page crashed after sign in. Reload the page first; if it happens again, open the browser console and send the red error message.
                    </p>
                    {this.state.error?.message ? (
                        <div className="mt-4 rounded-2xl bg-slate-100 px-4 py-3 text-left text-xs text-slate-700">
                            {this.state.error.message}
                        </div>
                    ) : null}
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--color-primary,#001F3F)] px-4 py-3 font-semibold text-white shadow-lg shadow-slate-300/60 transition hover:brightness-90"
                    >
                        <RefreshCw size={18} />
                        Reload Workspace
                    </button>
                </div>
            </div>
        );
    }
}

export default AppErrorBoundary;
